import { useState } from "react";

const useHover = () => {
  const [ishovered, setIsHovered] = useState(false);
  const [hoveredData, setHoveredData] = useState(null);
  const handleMouseEnter = (data) => {
    setIsHovered(true);
    setHoveredData(data);
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
    setHoveredData(null);
  };
  return {
    handleMouseEnter,
    handleMouseLeave,
    ishovered,
    hoveredData,
  };
};

export default useHover;
